import { elegir } from '../ui/layout-variant.tsx';
import { CalendarioMobile } from './Calendario.mobile.tsx';
import { CalendarioDesktop } from './Calendario.desktop.tsx';

export default elegir(CalendarioMobile, CalendarioDesktop);
